import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=f00997a2&scoped=true"
import script from "./dataAnalysis.vue?vue&type=script&lang=js"
export * from "./dataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=f00997a2&prod&lang=less&scoped=true"
import style1 from "./dataAnalysis.vue?vue&type=style&index=1&id=f00997a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00997a2",
  null
  
)

export default component.exports